import { useCallback, useEffect, useState } from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import PrimaryButton from '../../components/ui/PrimaryButton';

export default function UserMsgNode({ data, id }) {

    const reactFlowInstance = useReactFlow();
    const currentUserMsgNode = reactFlowInstance.getNode(id)
    const parentNode = reactFlowInstance.getNodes().find(nd => nd.id === currentUserMsgNode.parentNode)

    const [inputValue, setInputValue] = useState(parentNode.user_inputs.find(usr_inp => usr_inp.id === id).input)
    const [isDefaultRadio, setIsDefaultRadio] = useState(parentNode.default_user_input === id)

    const updateUserReply = useCallback((evt) => {
        setInputValue(evt.target.value)
        data.setNodes((nds) => {
            return [
                ...nds.map(nd => nd.id === data.parentNodeId ? {
                    ...nd, user_inputs: nd.user_inputs.map(usr_inp => usr_inp.id === id ? {
                        ...usr_inp,
                        "input": evt.target.value,
                    } : usr_inp)
                } : nd),
            ]
        });
    }, [data, id]);

    const onRadioSelect = () => {
        data.setNodes((nds) => {
            return [
                ...nds.map(nd => nd.id === data.parentNodeId ? {
                    ...nd,
                    default_user_input: id
                } : nd),
            ]
        });
    }
    //checked = { parentNode.default_user_input === id }
    return (
        <>
            <div className='bg-slate-300 p-2 rounded flex gap-2 items-center w-[17rem]'>
                <input type="radio" id="default" name={'default_' + data.parentNodeId} value="DEFAULT" onChange={onRadioSelect} defaultChecked={isDefaultRadio}></input>
                <input
                    value={inputValue}
                    className="border-2 border-slate-300 p-2 rounded nodrag w-full" id="text" name="text" onChange={updateUserReply} />
            </div>
            <Handle type="source" position={Position.Right} />
        </>
    );
}